import api from './api';

const amcService = {
  getAMCs: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/amc?${queryString}`);
    return response.data;
  },

  getAMCById: async (id) => {
    const response = await api.get(`/amc/${id}`);
    return response.data;
  },

  createAMC: async (amcData) => {
    const response = await api.post('/amc', amcData);
    return response.data;
  },

  updateAMC: async (id, amcData) => {
    const response = await api.put(`/amc/${id}`, amcData);
    return response.data;
  },

  deleteAMC: async (id) => {
    const response = await api.delete(`/amc/${id}`);
    return response.data;
  },

  uploadImages: async (id, formData) => {
    const response = await api.post(`/amc/${id}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteImage: async (id, imageId) => {
    const response = await api.delete(`/amc/${id}/images/${imageId}`);
    return response.data;
  },

  generatePDF: async (id) => {
    const response = await api.get(`/amc/${id}/pdf`, {
      responseType: 'blob'
    });
    return response.data;
  }
};

export default amcService;